<template>
  <div class="quality-wrap">
    <div class="quality-bar">
      <div class="quality-bar__over" :style="{width: rateBarWidth + '%'}"></div>
    </div>
    <ul class="quality-list">
      <li
        v-for="(value, i) of rateCount"
        :key="value"
        class="quality-list__item">
        <div class="wrap-box">
          <input @change="handleChange"
                 type="radio"
                 :id="questionUid + value"
                 :name="questionUid + value"
                 :value="value"
                 :checked="value === rate"
                 class="visually-hidden">
          <label :for="questionUid + value" :style="{color: currentColor[i]}"><span :style="{color: '#333'}">{{ value }}</span></label>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RadioButtons',
  data: function () {
    return {
      rate: null,
      currentColor: [],
      step: 100 / (this.rateCount - 1)
    }
  },
  props: {
    rateCount: {
      type: Number,
      required: true
    },
    questionUid: {
      type: String,
      required: true
    },
    simpleQuestion: {
      type: Boolean,
      default: false
    },
    pollType: String,
    questionnaireUid: String
  },
  methods: {
    ...mapActions('questionnaire', ['SET_ANSWER_ACTION']),
    handleChange ({ target }) {
      this.rate = +target.value

      this.SET_ANSWER_ACTION({ uid: this.questionnaireUid, answerUid: this.questionUid, answer: [target.value], type: this.pollType })
    },
    getGradientColor (startColor, endColor, percent) {
      const redColor = Math.round(this.hexToRgb(startColor).r + percent / 100 * (this.hexToRgb(endColor).r - this.hexToRgb(startColor).r))
      const greenColor = Math.round(this.hexToRgb(startColor).g + percent / 100 * (this.hexToRgb(endColor).g - this.hexToRgb(startColor).g))
      const blueColor = Math.round(this.hexToRgb(startColor).b + percent / 100 * (this.hexToRgb(endColor).b - this.hexToRgb(startColor).b))

      return this.rgbToHex(redColor, greenColor, blueColor)
    },
    rgbToHex (r, g, b) {
      r = r.toString(16)
      g = g.toString(16)
      b = b.toString(16)

      if (r.length === 1) {
        r = '0' + r
      }
      if (g.length === 1) {
        g = '0' + g
      }
      if (b.length === 1) {
        b = '0' + b
      }

      return '#' + r + g + b
    },
    hexToRgb (hex) {
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b
      })

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null
    }
  },
  computed: {
    rateBarWidth () {
      return (this.rate === 1) ? 98 : 100 - (this.rate * this.step - this.step)
    }
  },
  mounted () {
    for (let i = 1; i <= this.rateCount; i++) {
      const percent = i * this.step - this.step
      const gradientBreakPoint = 70
      if (percent <= gradientBreakPoint) {
        this.currentColor.push(this.getGradientColor('#ED5959', '#FFEA2B', Math.round(percent / (gradientBreakPoint / 100))))
      } else {
        this.currentColor.push(this.getGradientColor('#FFEA2B', '#49D368', Math.round((percent - gradientBreakPoint) / (1 - gradientBreakPoint / 100))))
      }
    }
  }
}
</script>

<style lang="sass" scoped>

.quality-bar
  position: relative
  width: 100%
  height: 6px
  background: linear-gradient(90deg, #ED5959 0%, #FFEA2B 70.31%, #49D368 100%)
  overflow: hidden

.quality-bar__over
  position: absolute
  height: 100%
  top: 0
  right: 0
  background-color: $nd-border-color
  transition: width .4s

.quality-list
  list-style: none
  display: flex
  justify-content: space-between
  flex-flow: row wrap
  padding: 0
  margin: 14px 0 0 0

.quality-list__item
  overflow: hidden
  position: relative

  .wrap-box
    position: relative
    padding-bottom: 30px
    width: 26px

  input
    height: 0
    width: 0
    opacity: 0
    position: absolute

  input + label::before
    border: 1px solid currentColor
    content: ""
    height: 20px
    left: 3px
    position: absolute
    top: 25px
    width: 20px
    border-radius: 50%
    cursor: pointer

  input + label::after
    content: ""
    opacity: 0
    border: 5px solid currentColor
    border-radius: 50%
    position: absolute
    left: 8px
    top: 30px
    transition: opacity .2s
    cursor: pointer

  input:checked + label::after
    opacity: 1

  input:hover + label::before,
  input:focus + label::before
    box-shadow:  0 0 2px  rgba(0,0,0,0.4)

  label
    font-weight: 400
    font-size: 15px
    color: $text-color
    cursor: pointer
    margin: 0 auto
    display: block
    width: max-content
</style>
